import atoms from "../../../atoms";
import { RiDeleteBin6Line } from "react-icons/ri";
import { StoreSubAdminColumnProps, StoreSubAdminListProps, ViewStoreStaffProps } from "./interface";

const { Table, Button,Search } = atoms

const Index = ({ storeSubAdminList, handleDeleteSubAdmin,handleSearch }: ViewStoreStaffProps) => {
    const columns = [
        { name: 'S.No', selector: (row: StoreSubAdminColumnProps) => row.index_number },
        { name: 'User Name', selector: (row: StoreSubAdminColumnProps) => row?.user?.username ?? '-', },
        { name: 'Email', selector: (row: StoreSubAdminColumnProps) => row?.user?.email ?? '-', },
        { name: 'Action', selector: (row: StoreSubAdminColumnProps) => row.action, },
    ]

    return (
        <>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search searchCallBack={(e: string) => handleSearch(e)} />
                </div>
                <div className="col-6"></div>
            </div>
            {storeSubAdminList?.length > 0 ? <Table
                AdditionalClassName="add-invertory-table"
                columns={columns}
                data={storeSubAdminList?.map((item: StoreSubAdminListProps, index: number) => {
                    return ({
                        ...item,
                        index_number: index + 1,
                        action:
                            <Button className="table-delete-button fs-14 fw-400 ms-3"
                                onClick={() => handleDeleteSubAdmin(item?.id)}>
                                <div className='d-flex align-items-center'>
                                    <RiDeleteBin6Line />
                                    <span className='ms-2 mb-0'>Delete</span>
                                </div>
                            </Button>

                    })
                })}
            /> : <div className='justify-content-center d-flex mt-5 '>There are no records to display</div>}
        </>
    )
}

export default Index